__turbopack_context__.v({
  "cellIcon": "IhUUVa_cellIcon",
  "cellIconCheck": "IhUUVa_cellIconCheck",
  "cellIconCross": "IhUUVa_cellIconCross",
  "cellText": "IhUUVa_cellText",
  "divider": "IhUUVa_divider",
  "group": "IhUUVa_group",
  "groupColumnHeader": "IhUUVa_groupColumnHeader",
  "groupColumnHeaderCol": "IhUUVa_groupColumnHeaderCol",
  "groupRows": "IhUUVa_groupRows",
  "groupSectionTitle": "IhUUVa_groupSectionTitle",
  "root": "IhUUVa_root",
  "row": "IhUUVa_row",
  "rowIntro": "IhUUVa_rowIntro",
  "rowLabel": "IhUUVa_rowLabel",
  "rowValue": "IhUUVa_rowValue",
});
